import { render, staticRenderFns } from "./HistoryOrderModal.vue?vue&type=template&id=24de7722&scoped=true&class=container&"
import script from "./HistoryOrderModal.vue?vue&type=script&lang=js&"
export * from "./HistoryOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOrderModal.vue?vue&type=style&index=0&id=24de7722&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24de7722",
  null
  
)

export default component.exports